var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyFood = function SvgHappyFood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1E5FF",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2274E0",
    d: "M15.5 12.375h-11a.5.5 0 0 0 0 1h.53a.5.5 0 0 1 .417.223l.221.332a1 1 0 0 0 .832.445h7a1 1 0 0 0 .832-.445l.221-.332a.5.5 0 0 1 .416-.223h.531a.5.5 0 0 0 0-1M5.5 11.625h9a.25.25 0 0 0 .25-.25 4.76 4.76 0 0 0-3.638-4.618.125.125 0 0 1-.085-.173 1.11 1.11 0 0 0-.23-1.254 1.125 1.125 0 0 0-1.82 1.253.125.125 0 0 1-.085.173 4.76 4.76 0 0 0-3.642 4.619.25.25 0 0 0 .25.25m1.732-2.961a3.9 3.9 0 0 1 2.215-1.126.375.375 0 1 1 .106.742 3.14 3.14 0 0 0-1.785.908.375.375 0 1 1-.536-.524"
  })));
};
export default SvgHappyFood;